/** @jsxImportSource @emotion/react */

import React, { useState } from 'react';
import { useAppDispatch } from '../../../core/store';
import { DistributionListGroup } from '../models/distributionListGroup';
import { DistributionListGroupCardReadOnly } from './DistributionListGroupCardReadOnly';
import { deleteDistributionListGroup, removeEmptyGroup } from '../store/distributionListGroupSlice';
import { DistributionListGroupCardWritable } from './DistributionListGroupCardWritable';

interface DistributionListGroupCardProps {
  distributionListGroup: DistributionListGroup;
  editable?: boolean;
}

export const DistributionListGroupCard = ({ distributionListGroup, editable = false }: DistributionListGroupCardProps): JSX.Element => {
  const [edit, setEdit] = useState(editable);
  const dispatch = useAppDispatch();
  const onDelete = (id: string) => dispatch(deleteDistributionListGroup(id));

  const onEdit = () => {
    setEdit(true);
  };

  const onCancel = () => {
    if (distributionListGroup.id === '') {
      dispatch(removeEmptyGroup());
    }
    setEdit(false);
  };

  return edit || distributionListGroup.id === '' ? (
    <DistributionListGroupCardWritable group={distributionListGroup} onCancel={onCancel}/>
  ) : (
    <DistributionListGroupCardReadOnly distributionListGroup={distributionListGroup} onEdit={onEdit} onDelete={onDelete} />
  );

};